import { generateBaseQueryKeysList } from '@/queries/utils';

export const OPO_CASE_KEYS = {
  main: 'opoCases',
};

export const opoCaseQueryKeys = generateBaseQueryKeysList(OPO_CASE_KEYS.main);
